import { proxyUrl } from '@shared/utils';

const downloadFile = async (href: string, mimetype: string, filename: string) => {
  const url = proxyUrl(href, filename, mimetype);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadFile;
